<template>
  <el-card>
    <el-row class="common-margin">
      <el-row>
        <el-col :span="12">
          <el-button
              class="btns-add"
              icon="el-icon-plus"
              size="small"
              @click="add"
              v-if="isShowEnroll"
          >添加品牌</el-button
          >
        </el-col>
      </el-row>
      <el-table
          :data="tableData"
          :max-height="tableHeight"
          style="width: 100%; margin-bottom: 20px; margin-top: 20px"
          border
      >
        <el-table-column type="index" width="80px" align="center" label="序号"> </el-table-column>
        <el-table-column prop="contacts" align="center" label="联系人"></el-table-column>
        <el-table-column prop="contacts" align="center" label="公司名称">
          <template slot-scope="scope">
            <div>{{getName(scope.row)}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="logo" align="center" label="图片" width="140">
          <template slot-scope="scope">
            <el-image
                v-if="scope.row.logo"
                style="width: auto;height: 20px;"
                :src="scope.row.logo"
                :preview-src-list="scope.row.logoList"
                fit="contain"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="phone" align="center" label="手机号码" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="操作" width="120">
          <template slot-scope="scope">
            <el-button
                size="mini"
                icon="el-icon-refresh"
                type="text"
                @click="updateItem(scope.row)"
            >更新</el-button
            >
            <el-button size="mini" icon="el-icon-document-add" type="text" @click="addBrandOrProduct(scope.row.id)">选择产品</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes"
          :total="total"
      >
      </el-pagination>
    </el-row>

    <el-dialog width="40%" :close-on-click-modal="false" :modal="false" :visible.sync="visible">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="120px" class="add-form">
        <el-form-item prop="contacts" label="联系人：">
          <el-input v-model.trim="form.contacts"></el-input>
        </el-form-item>
        <el-form-item prop="phone" label="手机号：">
          <el-input v-model.trim="form.phone"></el-input>
        </el-form-item>
        <el-form-item prop="email" label="说明：">
          <el-input v-model.trim="form.email" type="textarea" :rows="6"></el-input>
        </el-form-item>
        <div class="info-footer">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="save">确 定</el-button>
        </div>
      </el-form>
    </el-dialog>

    <el-dialog width="72%" title="添加产品" :close-on-click-modal="false" :modal="false" :visible.sync="outerVisible">
      <MeetBrandProduct ref="meetBrandProductRef" @isShowActivity="isShowActivity" />

      <el-dialog
          class="exhibition-dialog"
          title="可选产品"
          width="74%"
          :close-on-click-modal="false"
          :visible.sync="innerVisible"
          append-to-body>
        <MeetBrandProductList ref="meetBrandProductListRef" @success="successAdd" />
      </el-dialog>
    </el-dialog>
  </el-card>
</template>

<script>
import MeetBrandProduct from './meetBrandProduct.vue'
import MeetBrandProductList from './meetBrandProductList.vue'

export default {
  name: 'index',
  props: ['isShowEnroll', 'listType'],
  data () {
    return {
      id: '',
      tableData: [],
      tableHeight: 0,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      visible: false,
      meetRecordId: '',
      form: {
        meetRecordId: '',
        phone: '',
        contacts: '',
        email: ''
      },
      rules: {
        phone: {
          required: true,
          message: '请填写手机号码',
          trigger: 'blur'
        },
        contacts: {
          required: true,
          message: '请填写联系人',
          trigger: 'blur'
        },
        email: {
          required: true,
          message: '请填写说明',
          trigger: 'blur'
        }
      },
      outerVisible: false,
      innerVisible: false,
      recordId: ''
    }
  },
  components: {
    MeetBrandProduct,
    MeetBrandProductList
  },
  created () {
    this.tableHeight = document.documentElement.clientHeight - 600
  },
  methods: {
    async getPageList (id) {
      this.id = id
      this.tableData = []
      this.total = 0
      let {data: res} = await this.$http.post('/meetSession/meetSession/getMeetRecordList', {
        meetSessionId: id,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      })
      if (res.code === '200') {
        this.tableData = res.data.records
        this.tableData.forEach(item => {
          if (item.logo) {
            item.logoList = item.logo.split(',')
            item.logo = item.logo.split(',')[0]
          } else {
            item.logo = ''
            item.logoList = []
          }
          if (item.cosmeticBrand && item.cosmeticBrand.logo) {
            item.logoList = item.cosmeticBrand.logo.split(',')
            item.logo = item.cosmeticBrand.logo.split(',')[0]
          }
          if (item.professionalBrand && item.professionalBrand.logo) {
            item.logoList = item.professionalBrand.logo.split(',')
            item.logo = item.professionalBrand.logo.split(',')[0]
          }
        })
        this.total = parseInt(res.data.total)
      } else {
        this.$message.error(res.msg)
      }
    },
    add () {
      this.$emit('isShowActivity', this.id)
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getPageList(this.id)
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getPageList(this.id)
    },
    updateItem (data) {
      this.form.meetRecordId = data.id
      this.form.contacts = data.contacts
      this.form.phone = data.phone
      this.form.WeChat = data.WeChat
      this.form.email = data.email
      this.visible = true
    },
    getName (data) {
      if (data.cosmeticBrand) {
        return data.cosmeticBrand.name
      }

      if (data.professionalBrand) {
        return data.professionalBrand.name
      }

      if (data.company) {
        return data.company.fullName
      }

      return ''
    },
    cancel () {
      this.visible = false
      this.form = {
        meetRecordId: '',
        phone: '',
        contacts: '',
        WeChat: '',
        email: ''
      }
    },
    save () {
      this.$refs.formRef.validate(async (val) => {
        if (val) {
          let { data: res } = await this.$http.post('meetSession/meetSession/updateMeetRecord', this.form)
          if (res.code === '200') {
            this.visible = false
            this.$message.success(res.msg)
            await this.getPageList(this.id)
          } else {
            this.$message.error(res.msg)
          }
        }
      })
    },
    addBrandOrProduct (id) {
      this.outerVisible = true
      this.recordId = id
      this.$nextTick(() => {
        this.$refs.meetBrandProductRef.getPageList(id)
      })
    },
    isShowActivity () {
      this.innerVisible = true
      this.$nextTick(() => {
        this.$refs.meetBrandProductListRef.getPageList(this.recordId)
      })
    },
    successAdd () {
      this.innerVisible = false
      this.$refs.meetBrandProductRef.getPageList(this.recordId)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/meetSession/bannerAndAdvertIndex.vue